module.exports = __webpack_public_path__ + "static/media/Logo.90b3bafd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Logo.png
// module id = 84
// module chunks = 0